// generated by srcset-codegen
import src from "./office.svg";

const width = 30;
const height = 30;
export default { src, width, height };
